module.exports = __webpack_public_path__ + "media/images/icons/twotone/message-68e79fa0e9e286797591b118ed36bb35.svg";